<template>
    <div class="bdoCheckbox">
        <div v-for="(item, index) in checkboxDataList" :key="index">
            <el-checkbox v-model="item.chooseFlag" :label="item.productName" border></el-checkbox>
        </div>
    </div>
</template>
<script>
export default {
    name: "BdoCheckbox",
    props: {
        checkboxList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            checkboxDataList: []
        }
    },
    created() {
        this.checkboxDataList = this.checkboxList.map(value => {
            return {
                ...value,
                chooseFlag: typeof value.chooseFlag == 'string' ? value.chooseFlag == "1" ? true : false : value.chooseFlag
            }
        })
    },
    computed: {
        checkboxData() {
            return this.checkboxDataList.map(val => val.chooseFlag).join()
        }
    },
    watch:{
        checkboxData:function() {
            let data = this.checkboxDataList.map(value => {
                return {
                    ...value,
                    chooseFlag: typeof value.chooseFlag == "boolean" ? value.chooseFlag ? "1" : "2" : value.chooseFlag
                }
            })
            this.$emit("checkboxClick", data)
        },
        checkboxList:function(val) {
            if(val && val.length > 0) {
                this.checkboxDataList = val.map(value => {
                    return {
                        ...value,
                        chooseFlag: typeof value.chooseFlag == 'string' ? value.chooseFlag == "1" ? true : false : value.chooseFlag
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.bdoCheckbox {
    ::v-deep .el-checkbox {
        width: 378px;
        height: 48px;
        border-color: #99C1E7;
        border-radius: 8px;
        padding: 13px 16px;
        margin-bottom: 16px;
        &.is-checked {
            border-color: #99C1E7;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color:#0072D8;
            border-color: #0072D8;
        }
        .el-checkbox__inner {
            border-radius: 4px;
        }
        .el-checkbox__label {
            font: normal normal normal 16px/20px Nunito;
            color: #2E2E2E;
            padding-left: 16px;
        }
    }
}
</style>